customElements.define('recently-viewed-products', class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();

    this.containers = [
      this.querySelector('.splide__list'),
      this.querySelector('.grid')
    ]

    // Hide section if no history data found
    // History data is set from global.js 
    this.history = sessionStorage.getItem('Woolman_Product_History') ? sessionStorage.getItem('Woolman_Product_History').split(',') : [];
    if (!this.history || this.history.length === 0) {
      this.containers.forEach((container) => {
        if (!container) return;
        const section = container.closest('recently-viewed-products');
        section.setAttribute('hidden', true);
      })
    };

    // Initialize containers
    this.containers.forEach((container) => {
      if (!container) return;
      this.initContainer(container);
    })

    // Initialize items
    this.initItems();
  }

  /* This function fetches item HTML snippets and passes them to initContainer function */
  async initItems() {
    const promises = [];
    const rootUrl = window.routes.root == '/' ? '/' : window.routes.root + '/'; // if user has selected locale convert root url from /en-gb to /en-gb/
    this.history.forEach((productHandle) => {
      promises.push(fetch(`${rootUrl}products/${productHandle}?view=card`));
    });

    const settledPromises = await Promise.allSettled(promises);
    settledPromises.forEach(async (promise) => {
      if (promise.value.status != 404) {
        const html = await promise.value.text();
        
        this.containers.forEach((container) => {
          if (!container) return;

          const firstChildClass = container.dataset.firstChildClass;
          const firstChildNodeType = container.dataset.firstChildNodeType;
          const item = document.createElement(firstChildNodeType);
          item.className = firstChildClass;
          item.innerHTML = html;
          container.appendChild(item);  
        });
      } else {
        //this.history.replace('data-','')
      }
    });
  }

  /**
   * Initialize the container with required data
   * @param {HTMLElement} container 
   */
  initContainer(container) {
    // Get class of first child in provided container
    const firstChildClass = container.firstElementChild.className;
    container.dataset.firstChildClass = firstChildClass;

    // Get node type of first child in provided container
    const firstChildNodeType = container.firstElementChild.nodeName;
    container.dataset.firstChildNodeType = firstChildNodeType;

    container.innerHTML = '';
  }
})